import React from 'react';
import { ImageAndTiles as ImageAndTilesProps, SanityKeyed } from 'types/studio/studio';
import { ImageAndTilesVariation1 } from './Variation1/Variation1';
import { ImageAndTilesVariation2 } from './Variation2/Variation2';
import { CommonSectionProps } from '../types';

const ImageAndTiles = (props: SanityKeyed<ImageAndTilesProps> & CommonSectionProps) => {
  const { variation } = props;

  return variation === undefined || variation === '1' ? (
    <ImageAndTilesVariation1 {...props} />
  ) : (
    <ImageAndTilesVariation2 {...props} />
  );
};

export default ImageAndTiles;
